import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { UsersThree } from "@phosphor-icons/react";

/**
 * AdminCommunityFAB — Botón flotante Chat Comunidad (solo admins).
 * Espeja al ChatFAB (lado derecho) pero se ubica en el lado izquierdo.
 * Color: azul/cian para diferenciarse del ChatBot dorado.
 */
export default function AdminCommunityFAB() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  // Solo visible para admins en rutas de admin
  if (!user || user.role !== "admin") return null;
  if (!pathname.startsWith("/admin")) return null;

  return (
    <>
      <Link
        to="/comunidad"
        data-testid="admin-community-fab"
        title="Chat Comunidad"
        className="acfab acfab--admin"
        aria-label="Abrir Chat Comunidad"
      >
        {/* Anillos sonar */}
        <span className="acfab-ring acfab-ring-1" />
        <span className="acfab-ring acfab-ring-2" />

        {/* Círculo principal */}
        <span className="acfab-circle">
          <UsersThree weight="fill" className="acfab-icon" />
        </span>

        {/* Tooltip al hover (desktop) */}
        <span className="acfab-tooltip">Comunidad</span>
      </Link>

      <style>{`
        /* ── Contenedor ── */
        .acfab {
          position: fixed;
          left: 18px;
          z-index: 9999;
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        /* ── Posición mobile ── */
        .acfab--admin { bottom: 56px; }

        /* ── Posición desktop ── */
        @media (min-width: 1024px) {
          .acfab--admin { bottom: 22px; }
        }

        /* ── Círculo principal ── */
        .acfab-circle {
          position: relative;
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: linear-gradient(145deg, #60C8FF 0%, #2196F3 55%, #1565C0 100%);
          box-shadow:
            0 0 0 2px rgba(33,150,243,0.25),
            0 4px 18px rgba(33,150,243,0.5),
            0 2px 6px rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          animation: acfab-float 3.5s ease-in-out infinite;
          animation-delay: 0.8s;
        }

        /* ── Ícono ── */
        .acfab-icon {
          width: 22px;
          height: 22px;
          color: #fff;
          filter: drop-shadow(0 1px 2px rgba(0,0,0,0.4));
        }

        /* ── Flotado suave ── */
        @keyframes acfab-float {
          0%, 100% { transform: translateY(0);    }
          50%       { transform: translateY(-4px); }
        }

        /* ── Anillos sonar ── */
        .acfab-ring {
          position: absolute;
          border-radius: 50%;
          border: 2px solid rgba(33,150,243,0.55);
          pointer-events: none;
          width: 46px;
          height: 46px;
          top: 0;
          left: 0;
          animation: acfab-sonar 2.4s ease-out infinite;
          animation-delay: 0.8s;
        }
        .acfab-ring-2 {
          animation-delay: 2s;
          border-color: rgba(96,200,255,0.35);
        }

        @keyframes acfab-sonar {
          0%   { transform: scale(1);   opacity: 0.8; }
          100% { transform: scale(2.4); opacity: 0;   }
        }

        /* ── Tooltip — aparece a la derecha del botón ── */
        .acfab-tooltip {
          position: absolute;
          left: calc(100% + 10px);
          top: 50%;
          transform: translateY(-50%) translateX(-6px);
          background: rgba(10,10,14,0.92);
          border: 1px solid rgba(33,150,243,0.35);
          color: #60C8FF;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.06em;
          white-space: nowrap;
          padding: 5px 10px;
          border-radius: 6px;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease, transform 0.2s ease;
          backdrop-filter: blur(8px);
        }

        /* Tooltip visible en hover (desktop) */
        @media (min-width: 1024px) {
          .acfab:hover .acfab-tooltip {
            opacity: 1;
            transform: translateY(-50%) translateX(0);
          }
          .acfab:hover .acfab-circle {
            transform: scale(1.1);
            box-shadow:
              0 0 0 3px rgba(33,150,243,0.3),
              0 6px 28px rgba(33,150,243,0.65),
              0 2px 8px rgba(0,0,0,0.6);
            animation: none;
          }
        }

        /* ── Mobile: tap feedback ── */
        @media (max-width: 1023px) {
          .acfab:active .acfab-circle {
            transform: scale(0.92);
          }
        }
      `}</style>
    </>
  );
}
